<template>
  <div class="animated fadeIn">
    <b-row class>
      <b-col>
        <h2>ตั้งรหัสผ่านใหม่</h2>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <label for="email">อีเมล</label>
        <b-input-group>
          <b-form-input placeholder="ระบุอีเมลที่ใช้ลงทะเบียน" v-model="email" id="email"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <label for="password">รหัสผ่านใหม่</label>
        <b-input-group>
          <b-form-input placeholder="รหัสผ่านไม่น้อยกว่า 6 ตัวอักษร" v-model="password" id="password" :type="inputType"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <b-form-checkbox
          id="showPass"
          v-model="showPass"
          name="showPass"
          :value="true"
          :unchecked-value="false"
        >แสดงรหัสผ่าน</b-form-checkbox>
      </b-col>
    </b-row>
    <b-row v-if="email && (password.length >= 6)" class="mt-3">
      <b-col sm="6" md="4">
        <b-button variant="primary" @click="confirm">ยืนยัน</b-button>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import User from '../../services/http/User'
import ModalLoading from '../../components/ModalLoading'

export default {
  components: {
    ModalLoading
  },
  data () {
    return {
      email: null,
      password: null,
      showPass: false
    }
  },
  mounted () {
    window.analytics.track('reset-password-open')
  },
  methods: {
    async confirm () {
      Window.Event.$emit('showModalLoading')

      var user = new User()
      var data = {
        email: this.email,
        password: this.password,
        token: this.$route.params.token
      }
      try {
        var ret = await user.resetPassword(data)
        if (ret.code === 1) {
          await this.$bvModal.msgBoxOk('รหัสผ่านถูกตั้งใหม่แล้ว', this.$getConst('okModalClass'))
          window.analytics.track('reset-password-success')
          this.$router.push({ name: 'เข้าสู่ระบบ' })
        } else {
          await this.$bvModal.msgBoxOk('ระบุข้อมูลไม่ถูกต้อง', this.$getConst('okModalClass'))
        }
      } catch (error) {
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        console.log(error)
      }

      Window.Event.$emit('closeModalLoading')
    }
  },
  computed: {
    inputType () {
      if (this.showPass) {
        return 'text'
      } else {
        return 'password'
      }
    }
  }
}
</script>
